module.exports = __webpack_public_path__ + "static/img/icon_collect.fa4c3220.svg";